<template>
  <section class="thumbs-component">
    <v-touch @swipeleft="nextPage" @swiperight="previousPage" v-bind:enabled="!mobile">
      <section class="gallery__thumbs-wrapper"
               :style="{width: thumbsWidth + 'px'}">

        <Spinner v-show="!show"></Spinner>
        <ul class="gallery__thumbs"
            :style="{transform: 'translateX('+ containerPos +'px)'}">
          <ul class="gallery__thumb-set"
              :style="{width: thumbsWidth + 'px'}"
              v-for="page in imagesPaged">
            <li class="gallery__thumb"

                v-for="thumb in page">
              <a @click="selectImage(thumb.index)">
                <div class="gallery__shade" v-show="thumb.index !== currentNumber"></div>
                <transition name="slide-fade" appear>
                  <img :src="thumb.src" v-show="show">
                </transition>
              </a>

            </li>
          </ul>
        </ul>
      </section>
    </v-touch>

    <div class="thumb-controls">
      <div class="thumb-controls__wrapper" >
        <a @click="previousPage" :class="{active: canDecrement}" class="thumb-controls__prev"
           title="Previous"></a>
        <a @click="nextPage" :class="{active: canIncrement}" class="thumb-controls__next" title="Next"></a>
      </div>
    </div>
  </section>
</template>

<script>
  import eventHub from '@/plugins/EventHub'
  import preloader from '@/mixins/preloader';
  import Spinner from "@/components/Spinner";
  import {mapState} from "vuex";


  export default {
    name: "slider-thumbs",
    props: [
      'projectThumbs',
    ],
    components: {
      Spinner
    },
    mixins: [
      preloader
    ],
    data () {
      return {
        currentNumber: 0,
        show: false,
        tempArr: [],
        loadedCount: 0,
        loadedSet: [],
        images: [],
        imagesPaged: [],
        currentPage: 0,
        thumbWidth: 136,
        controlMargin: 64,
        compWidth: 0,
        windowWidth: 0,
        containerPos:0,
        debug: false,
      }
    },
    computed: {
      ...mapState([
        'mobile',
      ]),
      pages () {
        if (this.mobile) {
          return this.images.length;
        }
        return Math.ceil(this.images.length / this.pageSet);
      },
      canIncrement () {
        return (this.currentPage < this.pages - 1);
      },
      canDecrement () {
        return (this.currentPage > 0);
      },
      componentWidth () {
        //777
        return this.compWidth;
      },
      pageSet () {
        return Math.round(this.componentWidth / this.thumbWidth);
      },
      thumbsWidth () {
        return this.pageSet * this.thumbWidth - this.controlMargin;
      },

    },
    mounted () {
      this.init();
      eventHub.$on('next', this.next);
      eventHub.$on('prev', this.prev);
      this.compWidth = this.$el.clientWidth;
      // eventHub.$on('togglePlay', this.togglePlay);
      if (this.debug) console.log('current', this.currentPage);
      // console.log(this.$el.clientWidth);
    },
    methods: {

      selectImage (key) {
        this.currentNumber = key;
        eventHub.$emit('selectImage', key);
      },

      init () {
        // Reset Images in case the project changes without reinitializing the component
        this.resetImages();
        // Preload the images that are passed through via props
        // console.log(this.projectThumbs);
        this.preloadImages(this.projectThumbs, this.imagesReady);

        if (!this.mobile) {
          this.setComponentWidth();
        }

      },
      resetImages () {
        this.show = false;

        // Make sure to clean up any event listeners that are still out there on old images
        for (let i = 0; i < this.tempArr.length; i++) {
          this.tempArr[ i ].removeEventListener('load', this.imagesLoaded);
        }
        this.tempArr = [];
        this.images.splice(0);
        this.loadedCount = 0;
        this.currentNumber = 0;
      },
      imagesReady (tempArr) {
        // Once all images are loaded the tempArr replaces the images array
        this.images = tempArr;

        if (!this.mobile) {
          // Divide the images array into paged groups to allow markup to be styled for paging
          this.imagesPaged = this.createGroupedArray(this.images, this.pageSet);
        } else {
          this.imagesPaged = this.createGroupedArray(this.images, this.images.length);
        }


        // Now that all of the images are loaded and arrays are in place, flip the switch to reveal the thumbs
        this.show = true;

        // console.log('ready')
        // if (this.debug) console.log('pages ', this.pages);
        // if (this.debug) console.log(this.loadedSet);
        // if (this.debug) console.log('ImagesPaged: ', this.imagesPaged);
        // if (this.debug) console.log('ImagesPaged[0]: ', this.imagesPaged[ 0 ]);
        // if (this.debug) console.log(this.computedImages % this.pages);
        // if (this.debug) console.log('Groups ', this.createGroupedArray(this.images, this.pageSet));

      },

      setComponentWidth () {
        // Set the initial component width based off of the component's size
        this.compWidth = this.$el.clientWidth;

        let throttled = false;
        let delay = 250;

        this.$nextTick(function () {
          // Get difference between window size and component
          let tablet = window.innerWidth <= 1024;
          if (this.debug) console.log('tablet ', tablet);

          let diff = window.innerWidth - this.compWidth;
          if (this.debug) console.log('diff: ',diff);
          window.addEventListener('resize', (e) => {
            setTimeout((e)=> {

              if (!throttled) {
                // Check to see if the window crossed a breakpoint
                if (tablet && window.innerWidth > 1024) {
                  // Reset tablet value
                  tablet = window.innerWidth <= 1024;
                  // Recalibrate ratio
                  this.compWidth = this.$el.clientWidth;
                  diff = window.innerWidth - this.compWidth;
                } else if (!tablet && window.innerWidth <= 1024) {
                  tablet = window.innerWidth <= 1024;
                  this.compWidth = this.$el.clientWidth;
                  diff = window.innerWidth - this.compWidth;
                }

                if (this.debug) console.log('diff: ',diff);
                // Now set the component size to the same ratio when resized
                this.compWidth = window.innerWidth - diff;
                // Recompute the imagesPaged array so that the pageSet is based on the new window size
                this.imagesPaged = this.createGroupedArray(this.images, this.pageSet);
                // if (that.debug) console.log(that.windowWidth);
                throttled = true;

                setTimeout(function () {
                  throttled = false;
                }, delay);
              }
            }, 100);



          });
        })
      },
      next () {
        if (this.currentNumber < this.images.length - 1) {
          this.currentNumber += 1;
          this.checkPage(this.nextPage);
        } else {
          this.currentNumber = 0;
          this.currentPage = 0;
          this.containerPos = 0;
        }
      },
      prev () {
        if (this.currentNumber > 0) {
          this.currentNumber -= 1;
          this.checkPage(this.previousPage);
        } else {
          this.currentNumber = this.images.length - 1;
          this.currentPage = this.imagesPaged.length - 1;
          this.containerPos = -(this.thumbsWidth * this.currentPage);
        }
      },
      // Check to see if the current image is still in view on the current page,
      // if not then call the function needed to change pages
      checkPage (func) {
        // console.log('Current page: ',this.currentPage);
        // console.log('Images paged: ',this.imagesPaged);
        let numCheck = this.imagesPaged[ this.currentPage ].find((p) => {
          return p.index === this.currentNumber;
        });
        if (!numCheck) {
          func();
        }
      },
      nextPage () {
        if (this.canIncrement) {
          this.currentPage = this.currentPage + 1;
          this.containerPos = this.containerPos - this.thumbsWidth ;
        }
      },
      previousPage () {
        if (this.canDecrement) {
          this.currentPage = this.currentPage - 1;
          this.containerPos = this.containerPos + this.thumbsWidth ;
        }
      },
      // This will divide an array into chunks
      // So, arr = 15 items and chunkSize = 5, result will be an array with 3 child arrays,
      // with 5 items each
      createGroupedArray (arr, chunkSize) {
        let groups = [], i;
        // Add an Index property in order to allow an image click
        // to pass the index through for image selection
        for (let a = 0; a < arr.length; a++) {
          arr[ a ].index = a;
        }
        for (i = 0; i < arr.length; i += chunkSize) {
          groups.push(arr.slice(i, i + chunkSize));
        }
        if (this.debug) console.log(groups);

        return groups;
      },


    }
  }
</script>

<style scoped lang="scss">

  @import "./src/assets/scss/main";

  $thumbs-width: 300px;
  $controls-width: 100%;
  $white: white;
  $bb-dark-charcoal: #333333;
  $transition: all .2s linear;

  .gallery {
    z-index: 1;
    position: relative;
    overflow: hidden;
    //height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 4em;
    flex-grow: 2;

    @include media($mobile) {
      overflow: visible;
    }

    &__slider {

    }

    &__thumbs {
      display: flex;
      margin-bottom: 0;
      margin-top: 15px;
      overflow: scroll;
      //justify-content: center;
      //flex-wrap: wrap;

      @include media($mobile) {
        overflow: visible;
        flex-wrap: wrap;
      }


    }
    &__thumb {
      position: relative;
      height: 70px;
      margin-right: 15px;
      border: solid 1px $white;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      @include media($mobile) {
        margin-bottom: 15px;
      }

      img {
        width: auto;
        height: 100%;
      }

    }
    &__shade {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba($bb-dark-charcoal, .3);
      transition: $transition;
    }
    &__controls {
      position: absolute;
      top: 45%;
      width: 100%;
      display: flex;
      justify-content: space-between;
      a, span {
        display: block;
        /*background: url(../images/thumbs-next.png) no-repeat;*/
        width: 11px;
        height: 18px;
        background-size: contain;
      }
    }
    &__next {
      display: block;
      /*background: url('~assets/images/arrow.svg') no-repeat;*/
      width: 23px;
      height: 45px;
      background-size: contain;
    }
    &__prev {
      transform: rotate(180deg);
    }
  }


  .thumbs-component {
    position: relative;
    display: flex;
    justify-content: center;
    /*width: 100%;*/
    /*height: 100px;*/
  }

  .gallery__thumbs-wrapper {
    position: relative;
    height: 70px;
    overflow-x: hidden;
    //min-width: $thumbs-width;
    width: $thumbs-width;
    z-index: 2;

    @include media($mobile) {
      height: auto;
      overflow: visible;
      width: auto;
    }
  }

  .gallery__thumbs {

    @include media($tablet-up) {
      position: absolute;
      transition: transform .4s cubic-bezier(.42,0,1,1);
      /*height: 100px;*/
      overflow: auto;
      margin: 0;
    }
  }

  .gallery__thumb-set {
    min-width: $thumbs-width;
    width: $thumbs-width;
    max-width: 100vw;
    display: flex;
    flex-wrap: nowrap;
    flex: 0 0 auto;
    justify-content: center;
    margin: 0;

    @include media($mobile) {
      flex-wrap: wrap;
      width: 100%;
      flex: auto;
      justify-content: space-around;
      padding: 0 1em;
    }
  }

  .gallery__thumb {
    position: relative;

    &:last-child {
      margin-right: 0;
    }
  }

  .thumb-controls {
    position: absolute;
    display: flex;
    width: 100%;
    top: 25%;
    justify-content: center;
    /*z-index: 3;*/

    &__wrapper {
      position: absolute;
      width: $controls-width;
      display: flex;
      justify-content: space-between;

      @include media($mobile) {
        display: none;
      }
    }

    a {
      padding: 0 .5em;
      cursor: pointer;
      visibility: hidden;
      z-index: 100;

      &.active {
        visibility: visible;
        &:hover {
          color: goldenrod;
        }
      }
    }
  }

  .spinner-wrapper {
    display: block;
    position: relative;
    width: 100px;
    height: 68px;
    background-color: rgba(0, 0, 0, .5);
    border: 1px solid white;
  }

  .spinner {
    position: absolute;
    left: 50%;
    margin-left: -9px;
    top: 40%;
    z-index: 10;
  }

  ul {
    padding: 0;
    li {
      list-style-type: none;
    }
  }
</style>
